import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/call-rejected.vue
var o = {
	name: "DtIconCallRejected",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--call-rejected"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Call Rejected",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M7.603 2.146a.5.5 0 0 1 0 .707l-.771.771.771.772a.5.5 0 1 1-.707.707l-.771-.771-.771.771a.5.5 0 1 1-.708-.707l.772-.771-.772-.772a.5.5 0 1 1 .707-.707l.772.771.771-.771a.5.5 0 0 1 .707 0ZM.563 8.199c.839-.665 2.854-1.997 5.6-1.996A7.972 7.972 0 0 1 11.5 8.227c.445.404.395 1.052.018 1.43l-.724.723a1.043 1.043 0 0 1-1.274.157l-1.072-.643a1.043 1.043 0 0 1-.502-.988l.13-1.443a7.086 7.086 0 0 0-1.914-.26 7.6 7.6 0 0 0-2.085.294V8.98a1.04 1.04 0 0 1-.505.895l-1.104.663c-.41.247-.936.182-1.275-.156l.354-.354-.354.354-.698-.699C.093 9.281.072 8.59.564 8.2Zm2.514-.344a8.528 8.528 0 0 0-1.879 1.117.046.046 0 0 0 .004.004L.85 9.33l.353-.354.698.698a.043.043 0 0 0 .053.007l1.104-.664a.043.043 0 0 0 .02-.036V7.855Zm5.972-.04-.107 1.18a.043.043 0 0 0 .02.041l1.073.644c.017.01.038.007.052-.007l.723-.722a6.865 6.865 0 0 0-1.761-1.135Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=call-rejected.js.map